import { render, staticRenderFns } from "./ActosRevision.vue?vue&type=template&id=5a631252&scoped=true"
import script from "./ActosRevision.vue?vue&type=script&lang=js"
export * from "./ActosRevision.vue?vue&type=script&lang=js"
import style0 from "./ActosRevision.vue?vue&type=style&index=0&id=5a631252&prod&lang=scss"
import style1 from "./ActosRevision.vue?vue&type=style&index=1&id=5a631252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a631252",
  null
  
)

export default component.exports